import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../routers/constants";
import { detailCampaign, fetchListPostCampaign, fetchProductCampaign, updateCampaign } from "../../../../store/action/campaignsAction";
import FormEdit from "./form-edit";
import { useParams } from 'react-router-dom';
import React, { useEffect, useRef, useState } from "react";
import ListPosts from "./list-posts";
import { replaceNavigate, showErrorToasts } from "../../../../services/helpers/Helper";
import { fetchSettingPageInfo } from "../../../../store/action/settingPageAction";
const _ = require('lodash');

const CampaignEdit = (props) => {
   const { campaign, page, detailCampaign, fetchListPostCampaign, updateCampaign, fetchProductCampaign } = props;
   const params = useParams();
   const navigate = useNavigate();
   const { id } = params;
   const [isEdit, setIsEdit] = useState(false);
   const [campaignName, setCampaignName] = useState('');

   useEffect(() => {
      setCampaignName(campaign.campaign_name);
   }, [campaign.campaign_name]);

   useEffect(() => {
      if (id) {
         detailCampaign(id);
         fetchSettingPageInfo(id)
      } else {
         navigate(URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST);
      }
   }, [id]);

   useEffect(() => {
      if (id && !_.isEmpty(page)) {
         fetchListPostCampaign(id);
         fetchProductCampaign(id);
      }
   }, [id, page]);

   const handleUpdateStatusCampaign = () => {
      const { posts, products } = campaign;
      if (!campaign.is_active) {
         if (!posts.length) {
            showErrorToasts('Vui lòng chọn bài viết!');
            return;
         }

         if (!products.length) {
            showErrorToasts('Vui lòng chọn sản phẩm!');
            return;
         }
      }
      const data = {
         id: campaign.id,
         user_id: campaign.user_id,
         campaign_name: campaign.campaign_name,
         fb_page_id: campaign.fb_page_id,
         is_active: campaign.is_active == 1 ? 0 : 1
      }
      updateCampaign(data);
   }

   const handleUpdateNameCampaign = () => {
      if (campaignName != campaign.campaign_name) {
         const data = {
            id: campaign.id,
            user_id: campaign.user_id,
            campaign_name: campaignName,
            fb_page_id: campaign.fb_page_id,
            is_active: campaign.is_active
         }
         updateCampaign(data);
      }
      setIsEdit(false);
   }

   return (
      <div id="bot-scene-container" >
         <div id="bot-scene-content" className="scroll-light">
            <div className="sale-post-detail-header header-live-stream-container app-v2-header-wrapper">
               <div className="header-live-stream-left-side">
                  <Link to={URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST}>
                     <button type="button" className="app-btn app-btn-link app-btn-pd-none button-back-onboarding mr16">
                        <div className="svg-next-icon ic-arrow-left">
                        </div>
                     </button>
                  </Link>
                  <div className="header-left-side-layout">
                     <div className="wrapper-page">
                        <div className="app-v2-page-info-container">
                           <div className="app-v2-page-info-avatar">
                              <span content={page.name} className="app-avatar app-avatar-circle app-avatar-image" style={{ width: 24, height: 24, lineHeight: 24, background: "rgb(253, 189, 65)" }}>
                                 <img src={page.page_avatar} />
                              </span>
                           </div>
                           <div className="app-v2-page-info">
                              <span title={page.name} className="title-page">
                                 {page.name}
                              </span>
                              <span className="app-v2-page-info-id">
                                 <div className="hover-to-copy-wrapper">
                                    <div className="hover-to-copy-container">
                                       <div className="title-copy-to-clipboard child">
                                          ID: {page.social_id}
                                          <div className="svg-next-icon button-copy-to-clipboard" >
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </span>
                           </div>
                        </div>
                     </div>
                     <div className="header-live-stream-title-container">
                        <div className="header-live-stream-title">
                           <span className="breadcrumb-edit-inline-wrapper">
                              {isEdit
                                 ?
                                 <input type="text" autoFocus={true} className="app-next-input" value={campaignName} onChange={(e) => setCampaignName(e.target.value)} onBlur={handleUpdateNameCampaign} />
                                 :
                                 <div onClick={() => setIsEdit(true)} className="pointer">
                                    <span className="line-title" title={campaign.campaign_name}>
                                       {campaign.campaign_name}
                                    </span>
                                    <button type="button" className="app-btn app-btn-link app-btn-pd-none">
                                       <div className="svg-next-icon ml10 ic-edit-one-line">
                                       </div>
                                    </button>
                                 </div>
                              }
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="header-live-stream-right-side">
                  <div className="dynamic-tabs-container live-stream-tab-container mr-5">
                     <div className="tabs-header-container">
                        <div className="wrap-item">
                           <div className="header-tab-livestreams live tabs-header-item active">
                              <div className="tab-item-title"><span>
                                 <div className="items-menu-containers">
                                    <div className="item-menus">
                                       <div className="item-menu-background">
                                          <div className="svg-next-icon ic-video-live-stream">
                                          </div>
                                       </div>
                                    </div>
                                    <div className="title-menu">Kịch bản</div>
                                 </div>
                              </span>
                              </div>
                           </div>
                           <Link to={`${URL.TASK_MANAGEMENT}?campaign_id=${campaign.id}`}>
                              <div className="header-tab-livestreams order_list tabs-header-item">
                                 <div className="tab-item-title"><span>
                                    <div className="items-menu-containers">
                                       <div className="item-menus">
                                          <div className="item-menu-background">
                                             <div className="svg-next-icon ic-checked-fill">
                                             </div>
                                          </div>
                                       </div>
                                       <div className="title-menu">Chốt đơn</div>
                                    </div>
                                 </span>
                                 </div>
                              </div>
                           </Link>
                           <div className="header-tab-livestreams settings tabs-header-item">
                              <Link to={replaceNavigate(URL.POSTS_COMMENTS_SALE_POSTS_SETTING_CAMPAIGN, id)}>
                                 <div className="tab-item-title">
                                    <span>
                                       <div className="items-menu-containers">
                                          <div className="item-menus">
                                             <div className="item-menu-background">
                                                <div className="svg-next-icon ic-setting-circle">
                                                </div>
                                             </div>
                                          </div>
                                          <div className="title-menu">Cài đặt</div>
                                       </div>
                                    </span>
                                 </div>
                              </Link>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="extra-switch-container display-flex align-items-center">
                     <div className={`pointer ${!campaign.is_active && "text-danger"}`}>
                        Tạm ngưng
                     </div>
                     <div className="ml8">
                        <button type="button" className={`app-switch ${!campaign.is_active ? "app-switch" : "app-switch-checked"} app-switch-small app-v2-header-extra-item__switch`} onClick={handleUpdateStatusCampaign}>
                           <span className="app-switch-inner"></span>
                           <div className="app-click-animating-node"></div>
                        </button>
                     </div>
                     <div className="ml8 pointer">Kích hoạt</div>
                  </div>
               </div>
            </div>
            <div className="sale-post-container">
               <div className="sale-post-general">
                  <FormEdit />
                  <ListPosts />
               </div>
            </div>
         </div>

      </div>
   )
}

const mapStateToProps = (state) => {
   const { campaign, page } = state;
   return {
      campaign,
      page,
   };
};


export default connect(mapStateToProps, {
   detailCampaign,
   fetchListPostCampaign,
   updateCampaign,
   fetchProductCampaign,
   fetchSettingPageInfo
})(CampaignEdit);